
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M7.474 9.4V5.977c0-1.315-1.052-2.407-2.367-2.42a2.394 2.394 0 00-2.414 2.39v.531a.795.795 0 01-.797.797H.834a.795.795 0 01-.797-.797v-.531A5.052 5.052 0 015.1.9c2.79.01 5.03 2.308 5.03 5.097V9.4h7.833a2 2 0 012 2v4.5a2 2 0 01-2 2H7.088a2 2 0 01-2-2v-4.5a2 2 0 012-2h.386z","fill":"#525F7F"}})])
          )
        }
      }
    